export const SBOTD_TYPE = 'sbotd';
export const DECOR_TYPE = 'decor';
export const PRO_TYPE = 'pro';

export const SBOTD_PATH = 'SpecialBuyOfTheDay';
export const PRO_PATH = 'ProSpecialBuyOfTheWeek';

export const isSbotd = (specialBuyType) => specialBuyType === SBOTD_TYPE;
export const isPro = (specialBuyType) => specialBuyType === PRO_TYPE;

export const getPreviewDateFromParams = (search) => {
  const searchParams = new URLSearchParams(search);
  if (searchParams.has('previewDate')) {
    return searchParams.get('previewDate');
  }

  return null;
};

export const getSpecialBuyTypeFromPath = (pathname) => {
  if (pathname.includes(PRO_PATH)) return PRO_TYPE;
  if (pathname.includes(SBOTD_PATH)) return SBOTD_TYPE;

  return null;
};

export const getMetadata = (specialBuyType) => {
  switch (specialBuyType) {
  case PRO_TYPE:
    return {
      title: 'Pro Special Buy Of The Week: Find The Deal Of The Week at The Home Depot',
      // eslint-disable-next-line max-len
      description: 'Find the deal of the week and save on select Pro items with Home Depot\'s Pro Special Buy of The Week.',
      canonicalURL: '/SpecialBuy/ProSpecialBuyOfTheWeek',
      type: 'sbotd',
      siteName: 'The Home Depot',
      facebookAdmins: '100005416960152'
    };
  case SBOTD_TYPE:
    return {
      title: 'Special Buy Of The Day: Find The Deal Of The Day at The Home Depot',
      // eslint-disable-next-line max-len
      description: 'Find the deal of the day and save on select appliances, décor, and home improvement items with Home Depot\'s Special Buy of The Day.',
      canonicalURL: '/SpecialBuy/SpecialBuyOfTheDay',
      mobile: 'android-app://com.thehomedepot/homedepot/sbotd',
      type: 'sbotd',
      siteName: 'The Home Depot',
      facebookAdmins: '100005416960152'
    };
  default:
    return null;
  }
};
